import React from "react"

interface DoNotSellLinkProps {
  onOptOut: () => void
  className?: string
}

const DoNotSellLink = ({ onOptOut, className = `` }: DoNotSellLinkProps) => (
  <button
    type="button"
    aria-haspopup="dialog"
    onClick={onOptOut}
    className={className}
  >
    Do Not Sell or Share My Personal Information
  </button>
)

export default DoNotSellLink
